import tools from '../../../../assets/javascript/tools.js'
export default {
    columns: {
		title: {
			label: '部位及数量',
			visible: true,
			width: 'auto',
			align: "left"
		},   
		symptom: {
			label: '部位或个数',
      visible: true,
      width: "auto",
			align: "left"
		},
		auditStatus: {
			label: '审核状态',
			visible: true,
			width: 'auto',
			align: "left"
		},
		staffName: {
			label: '服务技师',
			visible: true,
			width: 'auto',
			align: "left"
		},
		
		oxCtime:{
			label: '修护时间',
			visible: true,
			formatDate: true,
			width: '150',
			align: "left"
		},
    }
}
